import { queryOptions } from "@tanstack/react-query";

const API_URL = import.meta.env.VITE_API_URL;

export interface NftDetail {
	price: number;
	sellbackPriceInCredits: number;
	sellbackPriceInUsd: number;
}

export const getMetadataOptions = (
	collectionAddress: string,
	tokenId: string,
) => {
	return queryOptions({
		queryKey: ["nfts", "metadata", collectionAddress, tokenId],
		queryFn: async () => {
			const resp = await fetch(
				`${API_URL}/nfts/metadata/?collectionAddress=${collectionAddress}&tokenId=${tokenId}`,
				{
					method: "GET",
					credentials: "include",
				},
			);
			if (!resp.ok) {
				return null;
			}
			const metadata = await resp.json();
			return metadata satisfies NftDetail;
		},
		retry: false,
		enabled: !!collectionAddress && !!tokenId,
		staleTime: 10 * 1000,
	});
};
